import { resto, userService } from '@saucelabs/sl-util-axios';

export const getOrgUsers = (username) => (
  resto.get(`/rest/v1.1/users/${username}/organization`)
);

export const getTeams = ({ limit = 99999, offset = 0 } = {}) => (
  userService.get('/v1/teams/', { params: { limit, offset } })
);
